// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__pljXA","buttons":"PendingPaymentAlert_buttons__d8eWV"};